<script setup lang="ts">
import { ref } from "vue";

const importMode = ref<"module" | "from">("module");
const result = ref("Ready");

function runImport() {
  result.value = importMode.value === "module"
    ? "import random -> ab random module available hai"
    : "from random import randint -> ab randint direct available hai";
}
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Cheez ko andar kaise laate hain?</h2>
      <p class="text-sm text-slate-600">Yahan dekho ke Python me doosri file ki cheez kaise use karte hain.</p>
    </div>

    <div class="mt-4 flex gap-2">
      <button type="button" class="rounded-full px-3 py-2 text-sm font-medium" :class="importMode === 'module' ? 'bg-slate-950 text-white' : 'bg-slate-100 text-slate-700'" @click="importMode = 'module'">
        poora module lao
      </button>
      <button type="button" class="rounded-full px-3 py-2 text-sm font-medium" :class="importMode === 'from' ? 'bg-slate-950 text-white' : 'bg-slate-100 text-slate-700'" @click="importMode = 'from'">
        sirf aik cheez lao
      </button>
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>{{ importMode === "module" ? "import random\nprint(random.randint(1, 10))" : "from random import randint\nprint(randint(1, 10))" }}</code></pre>

    <button type="button" class="mt-4 rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white" @click="runImport">
      Chalao
    </button>

    <div class="mt-4 rounded-2xl bg-sky-50 p-4 ring-1 ring-sky-100">
      <p class="text-sm text-slate-700">{{ result }}</p>
    </div>
  </section>
</template>
